import React, { useState } from 'react';

interface GuestEmailSubscription {
  id: number;
  email: string;
  is_active: boolean;
}

interface GlobalEmailNotificationToggleProps {
  guestEmailSubscription: GuestEmailSubscription;
  onSave: (isActive: boolean) => void;
}

const GlobalEmailNotificationToggle: React.FC<GlobalEmailNotificationToggleProps> = ({
  guestEmailSubscription,
  onSave
}) => {
  const [isActive, setIsActive] = useState(guestEmailSubscription.is_active);
  const [isSaving, setIsSaving] = useState(false);

  const handleToggle = () => {
    const newIsActive = !isActive;
    setIsActive(newIsActive);
    
    // Toast表示
    if (window.showGlobalFlash) {
      if (newIsActive) {
        window.showGlobalFlash('新着案件メールを受け取る設定を有効にしました', 'success', false);
      } else {
        window.showGlobalFlash('新着案件メールを受け取る設定を無効にしました', 'info', false);
      }
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave(isActive);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className={`bi ${isActive ? 'bi-toggle-on' : 'bi-toggle-off'} me-2`} style={{ fontSize: '24px', color: isActive ? '#00bb94' : '#6c757d', cursor: 'pointer' }} onClick={handleToggle}></i>
            <label className="form-check-label mb-0" htmlFor="global-email-notification-toggle" style={{ cursor: 'pointer' }} onClick={handleToggle}>
              新着案件メールを受け取る
            </label>
          </div>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleSave}
            disabled={isSaving || isActive === guestEmailSubscription.is_active}
          >
            {isSaving ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                保存中...
              </>
            ) : (
              '保存'
            )}
          </button>
        </div>
        <input
          type="checkbox"
          id="global-email-notification-toggle"
          checked={isActive}
          onChange={handleToggle}
          style={{ display: 'none' }}
        />
      </div>
    </div>
  );
};

export default GlobalEmailNotificationToggle;

